export default "__VITE_ASSET__95749c10__"